import PropTypes from 'prop-types'
import React from 'react'
import { NavLink } from 'react-router-dom'

const ExpensesNavLink = ({ path, children }) => (
  <NavLink to={path} className="nav-link" activeClassName="active">
    <span>{children}</span>
  </NavLink>
)

const paths = [
  '/expenses/all-amenities',
  '/expenses/electricity',
  '/expenses/gas',
  '/expenses/detail',
]

ExpensesNavLink.propTypes = {
  path: PropTypes.oneOf(paths).isRequired,
  children: PropTypes.node.isRequired,
}

export default ExpensesNavLink
